import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

//共享状态（即变量）
const state = {
  baseUrl: '/addons/cms/wxapp.',
  apiUrl: '',
  contactConfig: {
    phone: '425-999-6494',
    wechat: 'Aaron-518618',
    phone2: '425-999-6494',
  },
  tabs: [
    { title: '微信', url: 'icon-weixin', value: 'Aaron-518618' },
    // { title: 'line', url: 'icon-line', value: 'taotao-6688' },
    { title: 'Telegram', url: 'icon-telegram', value: '@seattletaotao' },
    { title: 'WhatsApp', url: 'icon-whatsapp', value: '425-999-6494' },
    { title: '短信', url: 'icon-duanxin', value: 'sms:（425）999-6494' },
  ],
  princessIndex: 0,
  scrollHeight:false,
  princess: {},
  initCache: {
    archivesList: [],
    bannerList: [],
    tabList: []
  },
  access: {
    name: '西雅图桃桃私人会所',
    icon: 'el-icon-s-unfold',
    tokenKey: 'keyID123'
  },
  metaInfo: {
    title: '西雅图桃桃私人会所',
    keywords: '西雅图桃桃私人会所，桃桃私人会所',
    description: '西雅图桃桃私人会所是西雅图私人高级会所之一，你都可以在我们的网站找到你想要的享受。'
  }
};

// 更改vuex的store中状态的唯一方法
const mutations = {
  //修改meta关键字与描述
  CAHNGE_META_INFO(state, metaInfo) {
    state.metaInfo = metaInfo;
  },
  //1.不带参数的方式
  chanageTo(state) {
    state.name = '李四';
  },
  //2.带参数
  chanageToParam(state, param) {
    state.name = param.name
  }
};

// 可用于异步请求
const actions = {
  getInitData(param) {

  },
};

//基于state的派生状态，可理解为组件中的计算属性
const getters = {
  formattter: state => {
    let postfix = '';
    return postfix;
  },
  formattterParam: (state) => (val) => {
    let postfix = '';
    return postfix;
  },
};


export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});



// WEBPACK FOOTER //
// ./src/vuex/store.js